import React from 'react';
import $ from "jquery";

import { sendRequest } from '../global.js';

export default class AddressInput extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      object: this.props.object,
      properties: this.props.properties,
    };
  }

  handleChange = (e) => {
    let object = this.state.object;
    var input = $(e.target);
    var key = input.attr("data-key");
    object[key] = input.val();
    this.setState({object: object});
    this.props.onChange(this.props.objectKey, object);
  }

  componentDidMount = () => {
    this.getOptions();
  }

  getOptions = (input) => {
    let properties = this.state.properties;
    const displayKey = properties.displayField || "name";
    let request = properties.request;
    // Load select options and autocomplete if edit is enabled 
    if (!request || properties.hostProperty) {
      return;
    }
    if (request.match(/:id/)) {
      if (this.props.parentId) {
        request = request.replace(":id", this.props.parentId);
      } else {
        return;
      }
    }
    let data = {scope: "headers"};
    if (properties.minSearch) {
      if (!input || input.length < properties.minSearch) {
        if (this.state.options && this.state.options.length > 0) {
          this.setState({options: []});
        }
        return;
      }
      data[displayKey] = input;
    }
    data.name = this.props.objectKey;
        
    sendRequest({
      method: request,
      type: "GET",
      data: data,
      success: (data) => {
        let container = $('div[data-key="' + this.props.objectKey + '"]');
        let dataKeys = Object.keys(data);
        for (let i = 0; i < dataKeys.length; i++) {
          let dataKey = dataKeys[i];
          let input = container.find('input[data-key="' + dataKey + '"]');
          input.typeahead({source: [...new Set(data[dataKey])].filter(i => !!i)});
          input.on("change", this.handleChange);
        }
      },
      error: (xhr, status, err) => {
      }
    });
  }

  componentWillReceiveProps = (props) => {
    if (typeof props.object !== "undefined" && props.object !== null) {
      this.setState({object: props.object});
    }
  }

  render = () => {
    var properties = this.state.properties;
    var inputs = Object.keys(this.state.object).map((key) => {
      return(
        <input
          key={key}
          data-key={key}
          type="text"
          placeholder={properties.placeholder[key]}
          value={this.state.object[key]}
          onChange={this.handleChange}
          readOnly={this.props.disabled}
          className={"form-control"}
        />
      )
    });
    return (
      <div data-key={this.props.objectKey}>
        {inputs}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/input/AddressInput.js